import {
    GET_ALL_TYPES
} from './constants';

const initialState = {
    allTypes: [],
};

export default (state = initialState, action) => {
    switch (action.type) {
        case GET_ALL_TYPES: {
            return {
                ...state,
                allTypes: action.payload,
            };
        }
        default:
            return state;
    }
};

